// extracted by mini-css-extract-plugin
export var lg = "_3k-4";
export var md = "_3k-3";
export var sm = "_3k-2";
export var xs = "_3k-1";
export var xxs = "_3k-0";